
import {Vue, Component, Prop} from 'vue-property-decorator';
import {
  queryBookingOrderAuditUse,
  queryHqPackingListDistribute,
  queryPurchaseOrderDistribute
} from "@/api/booking-order";
import {divide} from "@/utils/number";

@Component({name: 'poFeeSettlement'})
export default class PoFeeSettlement extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({default: []}) private factoryInfos: any[];
  @Prop({ default: "" }) private bookingOrderId: string;

  private useVisible = false;
  private purchaseOrderDistributeVisible = false;
  private purchaseOrderDistributeLoading = false;

  private hqPackingListDistributeVisible = false;
  private hqPackingListDistributeLoading = false;

  private currentRow = {} as any;
  private tableCol = [
    {
      label: "采购订单号",
      prop: "purchaseOrderCode",
      key: "purchaseOrderCode",
      show: true,
      disabled: false,
      width: '150',
    },
    {
      label: "采购订单费用比",
      prop: "purchaseOrderFeeProportion",
      key: "purchaseOrderFeeProportion",
      show: true,
      disabled: false,
      type: "link",
      click: "purchaseOrderDistribute",
    },
    {
      label: "装箱单",
      prop: "hqPackingListCode",
      key: "hqPackingListCode",
      show: true,
      disabled: false,
      width: '150',
    },
    {
      label: "付款单费用比",
      prop: "paymentVoucherProportion",
      key: "paymentVoucherProportion",
      show: true,
      disabled: false,
      type: "link",
      click: "hqPackingListDistribute",
    },
    {
      label: "分配费用（总）",
      prop: "hqPackingListAmount",
      key: "hqPackingListAmount",
      show: true,
      disabled: false,
      render: (prop, row) => {
        return row.hqPackingListAmount.toFixed(2);
      },
      type: "icon_tooltip",
      iconTooltipContent: "此【采购订单】的【采购订单费用】分配到此【装箱单】中的部分",
    },
    {
      label: "已用费用（总）",
      prop: "usedDistributeAmount",
      key: "usedDistributeAmount",
      show: true,
      disabled: false,
      render: (prop, row) => {
        return row.usedDistributeAmount.toFixed(2);
      },
      type: "icon_tooltip",
      iconTooltipContent: "分配到装箱单中的【采购订单费用】在其他【报关合同】中已使用的费用",
    },
    {
      label: "可用费用（总）",
      prop: "canDistributeAmount",
      key: "canDistributeAmount",
      show: true,
      disabled: false,
      render: (prop, row) => {
        return (row.hqPackingListAmount - row.usedDistributeAmount - row.useAmount).toFixed(2);
      },
      type: "icon_tooltip",
      iconTooltipContent: "分配费用（总）- 已用费用（总） - 本次使用（总）",
    },
    {
      label: "使用费用比",
      prop: "usedProportion",
      key: "usedProportion",
      show: true,
      disabled: false,
      render: (prop, row) => {
        if (row.hqPackingListAmount !== 0) {
          const number = ((row.usedDistributeAmount + row.useAmount)/row.hqPackingListAmount);
          return (number * 100).toFixed(0) + '%';
        } else {
          return '0%';
        }
      },
      type: "icon_tooltip",
      iconTooltipContent: "(已用费用（总） + 本次使用（总）)/分配费用（总）",
    },
    {
      label: "本次使用（总）",
      prop: "useAmount",
      key: "useAmount",
      show: true,
      disabled: false,
      render: (prop, row) => {
        return row.useAmount.toFixed(2);
      }
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      show: true,
      disabled: false,
      type: "actions",
      options: [
        {
          name: "分配",
          click: "toDistribute",
          show: (row) => {
            return row.hqPackingListAmount !== 0;
          },
        },
      ],
    },
  ];
  private useTable = {
    list: [],
    tableCol: [
      {
        label: "费用名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "分配费用(¥)",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
        render: (prop, row) => {
          return row.amount.toFixed(2);
        },
      },
      {
        label: "可使用费用(¥)",
        prop: "canUseAmount",
        key: "canUseAmount",
        show: true,
        disabled: false,
        render: (prop, row) => {
          return row.canUseAmount.toFixed(2);
        },
      },
      {
        label: "本次使用(¥)",
        prop: "thisUseAmount",
        key: "thisUseAmount",
        type: "inputNumber",
        precision: 2,
        maxProp: "maxAmount",
        minProp: "minAmount",
        show: true,
        disabled: false,
      },
    ],
  };
  private productUseTable = {
    list: [],
    tableCol: [
      {
        label: "报关品名",
        prop: "invoiceDescription",
        key: "invoiceDescription",
        show: true,
        disabled: false,
      },
      {
        label: "货款金额占比",
        prop: "amountProportion",
        key: "amountProportion",
        render: (value) => {return `${value}%`},
        show: true,
        disabled: false,
        type: "icon_tooltip",
        iconTooltipContent: "该报关品名的货款合计，占装箱单中所在采购订单总金额的比例",
      },
      {
        label: "使用(¥)",
        prop: "purchaseOrderFee",
        key: "purchaseOrderFee",
        type: "inputNumber",
        precision: 2,
        maxProp: "maxAmount",
        minProp: "minAmount",
        show: true,
        disabled: false,
      },
      {
        label: "原单价(¥)",
        prop: "settlementUnitPrice",
        key: "settlementUnitPrice",
        show: true,
        disabled: false,
        render: (prop, row) => {
          return row.settlementUnitPrice.toFixed(2);
        }
      },
      {
        label: "现单价(¥)",
        prop: "nowUnitPrice",
        key: "nowUnitPrice",
        show: true,
        disabled: false,
        render: (prop, row) => {
          return row.nowUnitPrice.toFixed(2);
        }
      },
    ],
  }

  private poDistributeTable = {
    list: [],
    tableCol: [
      {
        label: "费用名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "金额",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
      },
      {
        label: "分配（总）",
        prop: "useAmount",
        key: "useAmount",
        show: true,
        disabled: false,
      },
      {
        label: "分配比例",
        prop: "useProportion",
        key: "useProportion",
        show: true,
        disabled: false,
      },
    ],
  }

  private poDistributeDetailTable = {
    tableCol: [
      {
        label: "费用名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "金额",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
      },
      {
        label: "分配",
        prop: "useAmount",
        key: "useAmount",
        show: true,
        disabled: false,
      },
      {
        label: "分配比例",
        prop: "useProportion",
        key: "useProportion",
        show: true,
        disabled: false,
      },
    ],
  }

  private pkDistributeTable = {
    list: [],
    tableCol: [
      {
        label: "费用名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "金额",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
      },
      {
        label: "分配（总）",
        prop: "useAmount",
        key: "useAmount",
        show: true,
        disabled: false,
      },
      {
        label: "分配比例",
        prop: "useProportion",
        key: "useProportion",
        show: true,
        disabled: false,
      },
    ],
  }

  private pkDistributeDetailTable = {
    tableCol: [
      {
        label: "费用名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "金额",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
      },
      {
        label: "分配",
        prop: "useAmount",
        key: "useAmount",
        show: true,
        disabled: false,
      },
      {
        label: "分配比例",
        prop: "useProportion",
        key: "useProportion",
        show: true,
        disabled: false,
      },
    ],
  }

  get remainingCanUse(): number {
    const totalUseAmount = this.useTable.list.reduce((sum, item) => sum + item.thisUseAmount, 0);
    const productUseAmount = this.productUseTable.list.reduce((sum, item) => sum + item.purchaseOrderFee, 0);
    return totalUseAmount - productUseAmount;
  }

  private async toDistribute(scope) {
    this.currentRow = scope.row;
    this.useTable.list = scope.row.useDetails;
    scope.row.auditProducts.forEach(item => {
      const settlementUnitPrice = divide(
          item.totalSettlementAmount,
          item.productNumberPcs,
          4
      );
      item.settlementUnitPrice = settlementUnitPrice;
      item.nowUnitPrice = settlementUnitPrice;
      const totalUseAmount = this.useTable.list.reduce((sum, item) => sum + item.canUseAmount, 0);
      if (totalUseAmount > 0) {
        item.maxAmount = totalUseAmount;
        item.minAmount = 0;
      } else {
        item.maxAmount = 0;
        item.minAmount = totalUseAmount;
      }
    })
    this.productUseTable.list = scope.row.auditProducts;
    this.useVisible = true;
  }

  // 报关合同分配采购订单费用-按比例分配
  private proportionUse() {
    const proportion = this.productUseTable.list.reduce((sum, item) => sum + item.amountProportion, 0);
    this.useTable.list.forEach(item => {
      const nextUsedAmount = item.amount * (proportion / 100);
      this.$set(item, 'thisUseAmount', nextUsedAmount);
    });
  }

  // 报关合同分配采购订单费用-全部使用
  private allUse() {
    this.useTable.list.forEach(item => {
      this.$set(item, 'thisUseAmount', item.canUseAmount);
    });
  }

  private proportionUseProduct() {
    const totalUseAmount = this.useTable.list.reduce((sum, item) => sum + item.thisUseAmount, 0);
    const total = this.productUseTable.list.reduce((sum, item) => sum + item.amountProportion, 0);
    this.productUseTable.list = this.productUseTable.list.map(item => {
      const purchaseOrderFee = totalUseAmount * (item.amountProportion / total);
      const nowUnitPrice = Number((
          (item.returnSettlementAmount -
          item.otherCharge -
          item.deductionAndFilling + purchaseOrderFee) / item.productNumberPcs).toFixed(2));
      return {
        ...item,
        purchaseOrderFee,
        nowUnitPrice,
      };
    });
  }

  private maxUse() {
    const totalUseAmount = this.useTable.list.reduce((sum, item) => sum + item.thisUseAmount, 0);
    if (!this.productUseTable.list.length) {
      return;
    }

    let maxIndex = 0;
    this.productUseTable.list.forEach((item, index) => {
      if (item.totalSettlementAmount > this.productUseTable.list[maxIndex].totalSettlementAmount) {
        maxIndex = index;
      }
    });

    this.productUseTable.list = this.productUseTable.list.map((item, index) => {
      if (index !== maxIndex) {
        return {
          ...item,
          purchaseOrderFee: 0,
          nowUnitPrice: item.settlementUnitPrice,
        };
      }
      const purchaseOrderFee = totalUseAmount;
      const nowUnitPrice = Number((
          (item.returnSettlementAmount -
          item.otherCharge -
          item.deductionAndFilling + purchaseOrderFee) / item.productNumberPcs).toFixed(2));
      return {
        ...item,
        purchaseOrderFee,
        nowUnitPrice,
      };
    });
  }

  private handleProductUseInputChange({ row, column }) {
    if (column.key !== "purchaseOrderFee") {
      return;
    }
    const item = row.row;
    const nowUnitPrice = Number((
        (item.returnSettlementAmount -
        item.otherCharge -
        item.deductionAndFilling + item.purchaseOrderFee) / item.productNumberPcs
    ).toFixed(2));
    this.$set(item, "nowUnitPrice", nowUnitPrice);
  }

  private confirmProportion() {
    if (this.remainingCanUse !== 0) {
      this.$message.error('还有剩余可使用费用，请将可使用费用分配完毕');
      return;
    }
    let remainingItems = JSON.parse(JSON.stringify(this.useTable.list));
    const result = [];
    for (const usage of this.productUseTable.list) {
      // 如果未使用金额，则跳过
      if (usage.purchaseOrderFee === 0) {
        result.push({ ...usage, usage: [] });
        continue;
      }
      let remainingUse = usage.purchaseOrderFee;
      const usageDetails = { ...usage, usage: [] };
      if (remainingUse > 0) {
        for (let i = 0; i < remainingItems.length; i++) {
          if (remainingUse === 0) {
            break;
          }
          const item = remainingItems[i];
          if (item.thisUseAmount > remainingUse) {
            usageDetails.usage.push({distributeId: item.id, useAmount: remainingUse});
            item.thisUseAmount = item.thisUseAmount - remainingUse;
            remainingUse = 0;
          } else {
            usageDetails.usage.push({distributeId: item.id, useAmount: item.thisUseAmount});
            item.thisUseAmount = 0;
            remainingUse = remainingUse - item.thisUseAmount;
          }
        }
      } else {
        for (let i = 0; i < remainingItems.length; i++) {
          if (remainingUse === 0) {
            break;
          }
          const item = remainingItems[i];
          if (item.thisUseAmount < remainingUse) {
            usageDetails.usage.push({distributeId: item.id, useAmount: remainingUse});
            item.thisUseAmount = item.thisUseAmount - remainingUse;
            remainingUse = 0;
          } else {
            usageDetails.usage.push({distributeId: item.id, useAmount: item.thisUseAmount});
            remainingUse = remainingUse - item.thisUseAmount;
            item.thisUseAmount = 0;
          }
        }
      }
      remainingItems = remainingItems.filter(item => item.thisUseAmount !== 0);
      result.push(usageDetails)
    }
    this.factoryInfos.forEach(item => {
      if (item.factoryName === this.currentRow.factoryName) {
        item.list.forEach(i => {
          if (i.hqPackingListId === this.currentRow.hqPackingListId && i.purchaseOrderId === this.currentRow.purchaseOrderId) {
            i.auditProducts = result;
            i.useDetails = this.useTable.list;
            i.useAmount = this.useTable.list.reduce((sum, item) => sum + item.thisUseAmount, 0);
          }
        })
      }
    });
    this.useVisible = false;
  }

  private close() {
    this.$emit("update:show", false);
  }

  private confirm() {
    const useInfos = [];
    this.factoryInfos.forEach(item => {
      item.list.forEach(i => {
        if (i.useDetails) {
          i.useDetails.forEach(usage => {
            if (usage.thisUseAmount !== 0) {
              const data = {
                hqPackingListId: i.hqPackingListId,
                purchaseOrderId: i.purchaseOrderId,
                distributeId: usage.id,
                useAmount: usage.thisUseAmount,
              }
              useInfos.push(data);
            }
          })
        }
      })
    });
    this.$emit("confirm", this.factoryInfos, useInfos);
    this.$emit("update:show", false);
  }

  private purchaseOrderDistribute = {};
  private async handlePurchaseOrderDistribute(scope) {
    this.purchaseOrderDistributeVisible = true;
    this.purchaseOrderDistributeLoading = true;
    const params = { purchaseOrderId: scope.row.purchaseOrderId };
    const res = await queryPurchaseOrderDistribute(params) as any;
    this.purchaseOrderDistribute = res;
    this.poDistributeTable.list = res.distributeInfos;
    this.purchaseOrderDistributeLoading = false;
  }

  private hqPackingListDistribute = {};
  private async handleHqPackingListDistribute(scope) {
    this.hqPackingListDistributeVisible = true;
    this.hqPackingListDistributeLoading = true;
    const params = { hqPackingListId: scope.row.hqPackingListId, purchaseOrderId: scope.row.purchaseOrderId };
    const res = await queryHqPackingListDistribute(params) as any;
    this.hqPackingListDistribute = res;
    this.pkDistributeTable.list = res.distributeInfos;
    this.hqPackingListDistributeLoading = false;
  }
}
